import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PROD_STAGE } from '../constants/application';
import { INTERNAL_ROLE_IDS } from '../constants/roles';
import { RootState } from '../redux/types';

export const useUnreleasedFeatures = () => {
    const user = useSelector((state: RootState) => state.userReducer.user);
    const stage = useSelector((state: RootState) => state.systemReducer.stage.value);

    const isUnreleasedFeaturesEnabled = useMemo(() => {
        if (stage && stage !== PROD_STAGE) return true;

        if (!user?.roles) return false;

        return user.roles.some((role) => INTERNAL_ROLE_IDS.includes(role));
    }, [stage, user]);

    return { isUnreleasedFeaturesEnabled };
};
